export const TRAVELNUMFLAG="TRAVELNUMFLAG"
export const ADDTRAVELNUMBER="ADDTRAVELNUMBER"
export const ADDTRAVELDETAILS="ADDTRAVELDETAILS"
export const ALLTRAVELDETAILS="ALLTRAVELDETAILS"